import { memo } from 'react';
import { IconMapPin, IconExternalLink } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { ICON_SIZE_SM, ICON_SIZE_2XS } from '@/constants/ui';
import { formatCoordinates } from '@/utils/helpers';
import styles from './LocationCard.module.css';

interface LocationCardProps {
  latitude: number;
  longitude: number;
  locationName: string | null;
  onNavigate?: () => void;
}

export const LocationCard = memo(function LocationCard({
  latitude,
  longitude,
  locationName,
  onNavigate,
}: LocationCardProps) {
  const { t } = useTranslation();

  const displayName = locationName ?? t('notes.detail.pinnedLocation');
  const coordinatesText = formatCoordinates(latitude, longitude);

  return (
    <div className={styles.card}>
      <div className={styles.icon} aria-hidden="true">
        <IconMapPin size={ICON_SIZE_SM} />
      </div>
      <div className={styles.textContent}>
        <span className={styles.locationName}>{displayName}</span>
        <span className={styles.coordinates}>{coordinatesText}</span>
      </div>
      {onNavigate && (
        <button type="button" className={styles.mapButton} onClick={onNavigate}>
          {t('notes.detail.onMap')}
          <IconExternalLink size={ICON_SIZE_2XS} />
        </button>
      )}
    </div>
  );
});
